/* Capelli — extras del menú mobile (drawer). Replica la vista completa de Capelli:
   nav (nativo) + VENTA INSTITUCIONAL + bloque de cuenta (CREAR CUENTA / INICIAR SESIÓN) + fila social.
   Se inyecta por JS para NO editar header-drawer.liquid (59KB, riesgo de corrupción en upload).
   Los íconos social se CLONAN del footer (usa las URLs ya configuradas; si no hay, se omite la fila). */
(function () {
  'use strict';
  var BUILT = 'cap-drawer-extra';

  function collectSocial() {
    var domains = ['instagram.com', 'facebook.com', 'tiktok.com', 'youtube.com',
                   'youtu.be', 'twitter.com', 'x.com', 'linkedin.com', 'pinterest.'];
    var out = [];
    var seen = {};
    var anchors = document.querySelectorAll('footer a[href], [class*="footer"] a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var href = a.getAttribute('href') || '';
      var low = href.toLowerCase();
      var match = false;
      for (var d = 0; d < domains.length; d++) { if (low.indexOf(domains[d]) !== -1) { match = true; break; } }
      if (!match) continue;
      if (seen[low]) continue;
      seen[low] = 1;
      var svg = a.querySelector('svg');
      if (!svg) continue;
      out.push({ href: href, svg: svg.outerHTML, label: (a.getAttribute('aria-label') || a.textContent || '').trim() });
    }
    return out;
  }

  function build(drawer) {
    if (!drawer || drawer.querySelector('.' + BUILT)) return;

    var box = document.createElement('div');
    box.className = BUILT;

    var html = '';
    // VENTA INSTITUCIONAL (link secundario, estilo nav)
    html += '<a class="cap-drawer-teamshop" href="/pages/venta-institucional">VENTA INSTITUCIONAL</a>';
    // Bloque cuenta (equivalente honesto al "membership" de Capelli, con rutas nativas de Shopify)
    html += '<div class="cap-drawer-member">' +
      '<p class="cap-drawer-member__text">Crea tu cuenta Capelli Sport para una compra más rápida, seguimiento de tus pedidos y beneficios exclusivos.</p>' +
      '<div class="cap-drawer-member__btns">' +
      '<a class="cap-drawer-btn cap-drawer-btn--solid" href="/account/register">CREAR CUENTA</a>' +
      '<a class="cap-drawer-btn cap-drawer-btn--outline" href="/account/login">INICIAR SESIÓN</a>' +
      '</div></div>';
    box.innerHTML = html;

    // Fila social (clonada del footer)
    var socials = collectSocial();
    if (socials.length) {
      var row = document.createElement('div');
      row.className = 'cap-drawer-social';
      var frag = '';
      for (var i = 0; i < socials.length; i++) {
        frag += '<a class="cap-drawer-social__link" href="' + socials[i].href + '" target="_blank" rel="noopener"' +
          (socials[i].label ? ' aria-label="' + socials[i].label.replace(/"/g, '') + '"' : '') + '>' +
          socials[i].svg + '</a>';
      }
      row.innerHTML = frag;
      box.appendChild(row);
    }

    // Insertar bajo el nav, ANTES de utility-links (localización queda fijada al fondo del drawer)
    var util = drawer.querySelector('.menu-drawer__utility-links');
    if (util && util.parentNode) {
      util.parentNode.insertBefore(box, util);
    } else {
      drawer.appendChild(box);
    }
  }

  // El panel nace bajo el header: fija --cap-drawer-top al pie real del #header-component.
  function positionDrawer() {
    var h = document.querySelector('#header-component');
    if (!h) return;
    var b = Math.round(h.getBoundingClientRect().bottom);
    if (b > 0) document.documentElement.style.setProperty('--cap-drawer-top', b + 'px');
  }

  function scan() {
    positionDrawer();
    var drawers = document.querySelectorAll('.menu-drawer');
    for (var i = 0; i < drawers.length; i++) build(drawers[i]);
  }

  window.addEventListener('resize', positionDrawer);

  // Reintentos temporizados: cubre el caso SSR (drawer ya en el DOM al cargar, sin mutación posterior).
  function scanSoon() { scan(); setTimeout(scan, 300); setTimeout(scan, 1200); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanSoon);
  } else {
    scanSoon();
  }
  window.addEventListener('load', scan);
  // Al abrir el drawer (details toggle) también se re-escanea, por si el theme lo renderiza en ese momento.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.header__drawer, header-drawer')) {
      setTimeout(scan, 60); setTimeout(scan, 300);
    }
  }, true);

  // El drawer puede re-renderizarse (Section Rendering API); re-inyectar si aparece de nuevo.
  // También se observa el atributo [open]: al abrir/cerrar, el header pasa a fixed (CSS :has) y hay
  // que recalcular --cap-drawer-top con la nueva altura del header (si no, el panel queda con un hueco).
  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes' && m.attributeName === 'open') { positionDrawer(); setTimeout(positionDrawer, 60); return; }
        if (m.addedNodes && m.addedNodes.length) { scan(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  } catch (e) {}
})();
